import React, { useEffect, useState } from 'react'
import { get } from '../../util/request';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import Datepicker from 'react-tailwindcss-datepicker';

const DetailAbsen = () => {
  const [state, setState] = useState({
    absensList: '',
    profile: '',
    form: {
      employee_id: '',
      company_id: '',
    },
    filter: 'all',
    startDate: format(new Date(), "yyyy-MM-dd") ,
    endDate: format(new Date(), "yyyy-MM-dd"),
    dateForm1: {
      startDate: '',
      endDate: ''
    },
    dateForm2: {
      startDate: '',
      endDate: ''
    },
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)



  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&attend=1&absence=2&permit=3&sick=4&start_date=${state.startDate}&end_date=${state.endDate}`
      if (state.filter === 'attend') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&attend=1&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'absence') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&absence=1&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'permit') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&permit=1&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'sick') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&sick=1&start_date=${state.startDate}&end_date=${state.endDate}`
      }

      getListAbsen(url)
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filter])

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&attend=1&absence=2&permit=3&sick=4&start_date=${state.startDate}&end_date=${state.endDate}`
      if (state.filter === 'attend') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&attend=1&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'absence') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&absence=2&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'permit') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&permit=3&start_date=${state.startDate}&end_date=${state.endDate}`
      } else if (state.filter === 'sick') {
        url = `public/api/v1/member/attendance/my_list?employee_id=${user.employee_id}&company_id=${user.company_id}&sick=4&start_date=${state.startDate}&end_date=${state.endDate}`
      }

      getListAbsen(url)
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.startDate, state.endDate])

  const getListAbsen = (url) => {
    get(
      url,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        console.log(success.data.Data)
        setState({
          ...state,
          absensList: success.data.Data,
          loading: false
        })

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleValueChange = (e, name) => {
    if (name === "dateForm1"){
      setState({
        ...state,
        [name]: e,
        startDate: e.startDate
      })
    } else {
      setState({
        ...state,
        [name]: e,
        endDate: e.endDate
      })
    }
    

  }


  const formatDate = (date) => {
    const dt1 = new Date(date);
    var d1 = format(dt1, 'dd/MM/yyyy')
    return d1
  }

  const formatTime = (date) => {
    let text = date;
    let hour = parseInt(text.slice(0, 2)) <= 10 ? "Pagi" : 
    parseInt(text.slice(0, 2)) > 10 && parseInt(text.slice(0, 2)) <= 14 ? "Siang" :
    parseInt(text.slice(0, 2)) > 14 && parseInt(text.slice(0, 2)) < 18 ? "Sore" : "Malam"
    let time = text.slice(0, 5);
    return time + " "+ hour
  }

  const handleSelected = (e) => {
    setState(prevState => {
      return {
        ...prevState,
        filter: e.target.value
      }
    })
  }
  return (
    state.loading ? "" :
      <div className='w-full h-screen grid-cols-1 bg-real-white sm:grid-cols-2'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
            <a href={process.env.PUBLIC_URL + "/profile"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Detail Profile</p>
          </div>
        </div>
        <div className='w-full px-4 bg-real-white'>
          <div className='flex justify-between py-4 border-b border-gray-100'>
            <p className='items-center font-bold'>Lihat lebih detail</p>
            <select id="countries" onChange={(e) => handleSelected(e)} className="w-1/2  bg-real-white border border-bg-primary text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option value="all">Semua</option>
              <option value="attend">Hadir</option>
              <option value="absence">Tidak Hadir</option>
              <option value="permit">Izin</option>
              <option value="sick">Sakit</option>
            </select>
          </div>
          <div className='flex w-full h-full gap-2 py-4'>
            <Datepicker
              asSingle={true}
              useRange={false}
              placeholder={"Tanggal Izin"}
              primaryColor={"blue"}
              value={state.dateForm1}
              onChange={(e) => handleValueChange(e, "dateForm1")}
            />
            <Datepicker
              asSingle={true}
              useRange={false}
              placeholder={"Tanggal Izin"}
              primaryColor={"blue"}
              value={state.dateForm2}
              onChange={(e) => handleValueChange(e, "dateForm2")}
            />

          </div>
        </div>
        <div>

          <div className='grid h-full grid-cols-1 bg-white rounded-3xl'>
            {state.absensList.map((item, index) => (
              <div className="p-4 mx-4 mt-4 rounded-lg bg-real-white" key={index}>
                <div className='flex'>
                  <p className='w-4 text-base'>1</p>
                  <p className='w-full text-base font-bold text-left'>{item.employee?.employee_fullname}</p>
                  <div className='flex text-xs text-grey-dark'>
                    {item.attendance_type === 1 ?
                      <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/checklist.svg"} className='w-4' /> :
                      item.attendance_type === 2 ?
                        <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/cross.svg"} className='w-4' /> :
                        item.attendance_type === 3 ?
                          <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/add.svg"} className='w-4' /> :
                          item.attendance_type === 4 ?
                            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/list.svg"} className='w-4' /> : ''
                    }
                  </div>
                </div>
                <div className='flex justify-between py-1'>
                  <div className='flex px-4 text-base font-semibold text-left '><img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/calendar.svg"} className='w-4 mr-1' />{formatDate(item.attendance_in_date)}</div>
                  <div className='flex text-base font-bold text-left '><img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/clock.svg"} className='w-4 mx-1' />{formatTime(item.attendance_in_time)}</div>

                </div>
                <div className='flex items-start py-1'>
                  <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/map-pin.svg"} className='w-4 ml-4 mr-1' />

                  <div className='flex w-full text-sm text-left'>
                    {item.address}
                  </div>
                </div>

              </div>
            ))}

          </div>
        </div>




      </div >
  )
}

export default DetailAbsen